var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74854 1.91844C1.74854 1.854 1.80077 1.80176 1.86521 1.80176H12.1328C12.1973 1.80176 12.2495 1.854 12.2495 1.91844V11.136C12.2495 11.2004 12.1973 11.2526 12.1328 11.2526H1.86521C1.80077 11.2526 1.74854 11.2004 1.74854 11.136L1.74854 1.91844ZM3.10062 3.14526C3.03618 3.14526 2.98394 3.1975 2.98394 3.26194V9.79245C2.98394 9.85689 3.03618 9.90913 3.10062 9.90913H10.8974C10.9619 9.90913 11.0141 9.85689 11.0141 9.79245V3.26194C11.0141 3.1975 10.9619 3.14526 10.8974 3.14526H3.10062Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8005 4.80029L2.19965 4.80029L2.19965 2.40007L11.8005 2.40007L11.8005 4.80029Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5676 0.000976562L10.5676 3.00126L9.1675 3.00126L9.1675 0.000976522L10.5676 0.000976562Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90015 0.000976562L4.90015 3.00126L3.50002 3.00126L3.50002 0.000976522L4.90015 0.000976562Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5676 0.000976562L10.5676 1.50112L9.1675 1.50112L9.1675 0.000976522L10.5676 0.000976562Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90015 0.000976562L4.90015 1.50112L3.50002 1.50112L3.50002 0.000976522L4.90015 0.000976562Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8078ca95ebb76e91e3e873a4a0ae9e9a.svg";
export { ForwardRef as ReactComponent };